import "@rails/actiontext"
import "@hotwired/turbo-rails"

import "../assets/stylesheets/application.scss"

import "./setup/handle_network_errors"
import "./setup/turbo_stream_actions"
import "./setup/nested_modals"
import "./setup/modal_morph_persistence"
import "./setup/modal_url_state"
import "./setup/stripe"
import "./setup/log_events"
import "./setup/track_usage"
import "./setup/turbo_frame_retry"
import "./setup/turbo_retry"
import "./setup/avo_boundary"
import "./setup/jank_meter"
import "./controllers/"

document.addEventListener('turbo:before-fetch-request', async (event) => {
  event.preventDefault()

  event.detail.fetchOptions.headers["TURBO_FETCH"] = true

  event.detail.resume()
})

